// theme.js

import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  // theme settings
  typography: {
    fontFamily: [
      'Montserrat',
      'sans-serif',
    ].join(','),
  },

  palette: {
    primary: {
      main: '#91994c',
      hover: '#4C5214',
    },
    secondary: {
      main: '#19857b',
    },
  },

});
export default theme;